import AppHeader from '../AppHeader'

export default {
  name: 'stepup',
  computed: {
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isShopMaster () {
      return this.$store.getters.shopMaster
    }
  },
  components: {
    AppHeader
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/stepup.js